import { Spin } from "antd";
import React from "react";

const Formcomponent = (props) => {
  const { isModal, form, onReset, onSubmit, loader } = props;

  return loader ? (
    <div className="flex justify-center items-center h-[60vh]">
      <Spin tip="Loading" size="large" />
    </div>
  ) : (
    <form
      className={
        isModal
          ? "bg-white p-4 rounded-md"
          : form?.[0]?.className
            ? form?.[0]?.className
            : "bg-white p-4 rounded-md p-8 w-[50%] mx-auto"
      }
      onReset={onReset}
      onSubmit={onSubmit}
      onKeyDown={(e) => {
        if (
          e.key === "Enter" &&
          e.target.tagName !== "TEXTAREA" &&
          e.target.tagName !== "BUTTON"
        ) {
          e.preventDefault();
        }
      }}
    >
      {props?.children}
    </form>
  );
};

export default Formcomponent;
